module.exports = __webpack_public_path__ + "static/media/blog04.d682b195.png";